import * as React from 'react';
import type { CommentAuthor } from './comment-types';

/**
 * Provides the current user as the author for new comments/replies. When the value is
 * `null`, the comment UI (toolbar button + popovers) renders nothing — this is how the
 * comment feature is enabled per editor instance (agents and documents opt in by
 * supplying an author; other embeddings of the editor leave it off).
 */
const CommentAuthorContext = React.createContext<CommentAuthor | null>(null);

export const CommentAuthorProvider = CommentAuthorContext.Provider;

export function useCommentAuthor(): CommentAuthor | null {
  return React.useContext(CommentAuthorContext);
}
